import { Paper, styled } from '@mui/material'

export const Container = styled(Paper, { name: 'Container' })({
  height: '100%',
  zIndex: 10,
})
